class MiniCart {
  constructor(cartEndpoint) {
    this.cartEndpoint = cartEndpoint ? cartEndpoint : "/cart.js";
    this.minicart = document.querySelector("[data-minicart]");
    this.items = document.querySelector("[data-minicart-items]");
    this.itemsJSON = [];
    this.item = "data-minicart-item";
    this.close = "data-minicart-close";
    this.open = "data-minicart-open";
    this.plus = "data-minicart-plus";
    this.minus = "data-minicart-minus";
    this.count = "data-minicart-count";
    this.siteTotal = document.querySelectorAll("[data-totalCount]");
    this.totalCount = document.querySelector("[data-minicart-totalCount]");
    this.remove = "data-minicart-remove";
    this.subtotal = document.querySelector("[data-minicart-subtotal]");
  }

  openCart(target) {
    if (this.minicart && target.hasAttribute(this.open)) {
      this.minicart.classList.add("open");
      this.minicart.classList.remove("close");
      document.querySelector('body').style.overflow = 'hidden';
      // init any sliders in cart
      mini_cart.initializeCrossSells();
    }
  }

  closeCart(target) {
    if (this.minicart && target.hasAttribute(this.close)) {
      this.minicart.classList.remove("open");
      this.minicart.classList.add("close");
      document.querySelector('body').style.overflow = 'scroll'; 
    }
  }

  updateTotalCount(total) {
    if (total != 0 && !total) return false;
    if (this.totalCount) {
      this.totalCount.innerHTML = total;
    }
    if(this.siteTotal) {
      this.siteTotal.forEach((item) => {
        item.innerHTML = total;
      })
      
    }
  }

  updateSubtotal(total) {
    if (!total) return false;
    if (this.subtotal) {
      this.subtotal.innerHTML = this.moneyFormat(total);
      this.subtotal.setAttribute("data-money", this.flatMoneyFormat(total));    }
  }

  initializeCrossSells() {
    if (window.Swiper) {
      CROSS_SELL_CONTROLLER.CROSS_SELLS = new Swiper(
        ".mini-cart_cross-sells", {
          slidesPerView: 1,
          initialSlide : 0,
          spaceBetween: 24
        }
      );
    }
  }

  async requestCart() {
    const response = await fetch(this.cartEndpoint, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    const cart = await response.json();

    return cart;
  }

  isRouteProtectionItem(item) {
    return item?.handle === 'routeins';
  }

  getVisibleCartState(cart) {
    const visibleItems = (cart?.items || []).filter((item) => !this.isRouteProtectionItem(item));
    const itemCount = visibleItems.reduce((total, item) => total + item.quantity, 0);
    const subtotal = visibleItems.reduce((total, item) => total + item.line_price, 0);

    return {
      visibleItems,
      itemCount,
      subtotal,
      isEmpty: visibleItems.length === 0
    };
  }

  applyCartState(cart, openCart = false) {
    if (!cart) {
      return;
    }

    const { itemCount, subtotal, isEmpty } = this.getVisibleCartState(cart);

    this.updateTotalCount(itemCount);
    this.updateSubtotal(subtotal);

    if (isEmpty) {
      this.isEmpty();
      return;
    }

    this.isFilled(openCart);
  }

  getCartFromEventDetail(eventDetail) {
    if (!eventDetail) {
      return null;
    }

    const possibleCartObjects = [
      eventDetail,
      eventDetail.cart,
      eventDetail.cart?.cart
    ];

    return possibleCartObjects.find((cart) => {
      return cart && Array.isArray(cart.items) && typeof cart.item_count !== 'undefined';
    }) || null;
  }

  async refreshCartSummary(openCart = false) {
    try {
      const cart = await this.requestCart();

      if (!cart) {
        return;
      }

      this.applyCartState(cart, openCart);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * DEPRECATED AS THE USE CASE FOR THIS FUNCTIONALITY IS HANDLED BY RIVETS
   * @param {Boolean} openCart
  */
  updateCartPartial(openCart = true) {
    fetch(this.cartEndpoint)
      .then((resp) => resp.json())
      .then((cart) => {
        if (cart) {
          var cartCount = cart.item_count;
          var subtotal = cart.total_price;
          let allItems = "";
          for (let item of cart.items) {
            //do not include Route Package Protection in Mini Cart
            if(item.product_title != 'Route Package Protection') {
              allItems += this.cartItemHTML(item);
            } else {
              cartCount = cartCount - item.quantity;
              subtotal = subtotal - item.line_price;
            }
          }

          this.updateSubtotal(subtotal);
          this.updateTotalCount(cartCount);

          if (cart.items.length < 1) {
            this.isEmpty();
          } else {
            if(cart.items.length == 1 && cart.items[0].handle == 'routeins') {
              this.isEmpty();
            } else {
              this.isFilled(openCart);
            }
          }
          
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  updateCart(openCart = true) {
    fetch(this.cartEndpoint)
      .then((resp) => resp.json())
      .then((cart) => {
        if (cart) {
          var cartCount = cart.item_count;
          var subtotal = cart.total_price;
          let allItems = "";
          
          
          for (let item of cart.items) {
            //do not include Route Package Protection in Mini Cart
            if(item.handle != 'routeins') {
              allItems += this.cartItemHTML(item);
            } else {
              cartCount = cartCount - item.quantity;
              subtotal = subtotal - item.line_price;
            }
          }
          this.updateSubtotal(subtotal);
          this.updateTotalCount(cartCount);

          // if (this.items) {
          //   this.items.innerHTML = allItems;
          // }

          /**
           *  Handle the state of the cart
           */
          if (cart.items.length < 1) {
            this.isEmpty();
          } else {
            if(cart.items.length == 1 && cart.items[0].product_title == 'Route Package Protection') {
              this.isEmpty();
            } else {
              this.isFilled(openCart);
            }
          }
          
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  updateCartNoAjax(openCart = true, cart) {
    if (cart) {
      var cartCount = cart.item_count;
      var subtotal = cart.total_price;
      let allItems = "";
      
      
      for (let item of cart.items) {
        //do not include Route Package Protection in Mini Cart
        if(item.handle != 'routeins') {
          allItems += this.cartItemHTML(item);
        } else {
          cartCount = cartCount - item.quantity;
          subtotal = subtotal - item.line_price;
        }
      }
      this.updateSubtotal(subtotal);
      this.updateTotalCount(cartCount);

      // if (this.items) {
      //   this.items.innerHTML = allItems;
      // }

      /**
       *  Handle the state of the cart
       */
      if (cart.items < 1) {
        this.isEmpty();
      } else {
        if(cart.items.length == 1 && cart.items[0].handle == 'routeins') {
          this.isEmpty();
        } else {
          this.isFilled(openCart);
        }
      }
      
    }
  }

  isFilled(openCart = true) {
    if (this.minicart) {
      this.minicart.classList.remove("empty");
      if (openCart) {
        this.minicart.classList.remove("close");
        this.minicart.classList.add("open");
      }
    }
  }

  isEmpty() {
    if (this.minicart) {
      this.minicart.classList.add("empty");
    }
  }

  removeCartItem(target) {
    if (target.hasAttribute(this.remove)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];
      if (id) {
        fetch("/cart/change.js", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
            quantity: 0,
          }),
        })
          .then((resp) => resp.json())
          .then((cart) => {
            this.updateCart();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }
  
  /**
   * DEPRECATED AS THIS FUNCTIONALITY IS HANDLED BY RIVETS
   * On click of Minus button of a cart detail on the mini cart, update the cart
   * @param {HTMLElement} target 
  */
  minusCartItem(target) {
    if (target.hasAttribute(this.minus)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];
      const quantityPicker = target.closest('.quantity-picker');
      const countElem = quantityPicker.querySelector(`[${this.count}]`);
      const newQuantity =
        countElem.textContent && parseInt(countElem.textContent) - 1;
      if (id) {
        fetch("/cart/change.js", {
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `quantity=${newQuantity}&id=${id}`,
        })
          .then(() => {
            if(newQuantity > 0) {
              countElem.innerHTML = newQuantity
              this.updateCartPartial();
            } else {
              this.updateCart();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  }
  
  /**
   * DEPRECATED AS THIS FUNCTIONALITY IS HANDLED BY RIVETS
   * On click of Plus button of a cart detail on the mini cart, update the cart
   * @param {HTMLElement} target 
  */
  plusCartItem(target) {
    if (target.hasAttribute(this.plus)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];
      const quantityPicker = target.closest('.quantity-picker');
      const countElem = quantityPicker.querySelector(`[${this.count}]`);
      const newQuantity =
        countElem.textContent && parseInt(countElem.textContent) + 1;
      if (id) {
        fetch("/cart/change.js", {
          method: "post",
          headers: {
            "x-requested-with": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `id=${id}&quantity=${newQuantity}`,
        })
          .then((resp) => resp.json())
          .then((data) => {
            if (data.status === 422) {
            } else {
              countElem.innerHTML = newQuantity;
              this.updateCartPartial();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  }

  addCartItem(id, target = null) {
      console.log(target)
    this.processAddToCartButtonJSON(target)
    // Add item to cart
    if (id) {
      CartJS.addItem(id, 1, null, {
        "success": function(data, textStatus, jqXHR) {
            mini_cart.updateCart();
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log('Error: ' + errorThrown + '!');
        }
      });
      
      // // DEPRECATED -- HANDLED BY CART JS
      // fetch("/cart/add.js", {
      //   method: "post",
      //   headers: {
      //     "x-requested-with": "XMLHttpRequest",
      //     "Content-Type": "application/x-www-form-urlencoded",
      //   },
      //   body: `id=${id}&quantity=1`,
      // })
      //   .then((resp) => resp.json())
      //   .then((data) => {
      //     if (data.status === 422) {
      //     } else {
      //       this.updateCart();
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error:", error);
      //   });
    }
  }

  processAddToCartButtonJSON(target) {
    if (target.getAttribute('data-json-id')) {
      const jsonSelector = `#${target.getAttribute('data-json-id')}`;
      const productCrossSellsJsonElement = document.querySelector(jsonSelector);
      const parentId = target.dataset.parentProduct;
      const currentProductsCrossSellsJSON = productCrossSellsJsonElement?.textContent
        ? JSON.parse(productCrossSellsJsonElement.textContent)
        : null;
      // all jsons in cart as an array
      const cartCrossSellsElement = document.querySelector("#CartCrossSells");
      const cartCrossSellsJSON = cartCrossSellsElement?.textContent
        ? JSON.parse(cartCrossSellsElement.textContent)
        : { crossSells: [] };
      // Populate the global cross sells json used for cross sells
      if (target) {
        if (currentProductsCrossSellsJSON) {
          const cartCrossSells = cartCrossSellsJSON.crossSells;
          if(cartCrossSells.length){
            var cartCrossSellIds = cartCrossSells.map(
              (crossSell) => {
                if(crossSell) {
                  Object.keys(crossSell)[0]
                } else {
                  null
                }
              }
            );
          }
          
          
          // Init and set up a cross sell object that represents the current product's cross sells, eventually to be pushed into the global cross sell json
          let crossSellObject = {}
          crossSellObject[parentId] = currentProductsCrossSellsJSON.crossSells;          
          
          //if this cross sell already exists in the global cross sells json
          if (cartCrossSellIds && cartCrossSellIds.includes(parentId)) {
            // Do nothing
  
            // const replaceIndex = cartCrossSellIds.indexOf(parentId);
            // cartCrossSells[replaceIndex] = crossSellObject;
          } else {
            //concat to global cross sells data
            cartCrossSells.push(currentProductsCrossSellsJSON.crossSells[0]);
            // rewrite the global cross sells json
            if (cartCrossSellsElement) {
              cartCrossSellsElement.textContent =
                '{"crossSells":' + JSON.stringify(cartCrossSells) + "}";
            }
          }
        }
      }
      }
    
  }

  cartItemHTML(item) {
    function buildProps(item) {
      if (
        !item ||
        !item.properties ||
        Object.keys(item.properties).length === 0
      )
        return "";

      let result = "";
      for (const [key, value] of Object.entries(item.properties)) {
        result += `<li>${key}: ${value}</li>`;
      }
      return result;
    }

    function buildOptions(item) {
      if (
        !item ||
        !item.options_with_values ||
        item.options_with_values.length === 0
      )
        return "";

      let result = "";
      for (let option of item.options_with_values) {
        if (option.value !== "Default Title") {
          result += `<li>${option.name}: ${option.value}</li>`;
        }
      }
      return result;
    }

    function getImage(image, size = 300) {
      if (!image) return "";
      const ext = image.match(/\.(?:jpg|gif|png)/g);
      return image.replace(ext[0], `_${size}x` + ext[0]);
    }

    function buildImage(item) {
      if (!item) return "";
      return `<img alt="" class="responsive-image__image lazyload" data-sizes="auto" src="${getImage(
        item.image,
        30
      )}" data-src="${getImage(item.image, 250)}">`;
    }

    let cartItem = miniCartItem;
    if (cartItem) {
      cartItem = cartItem.replace(/{{itemImage}}/g, buildImage(item));
      cartItem = cartItem.replace(/{{itemVariantId}}/g, item.id);
      cartItem = cartItem.replace(/{{itemTitle}}/g, item.product_title);
      cartItem = cartItem.replace(/{{itemUrl}}/g, item.url);
      cartItem = cartItem.replace(/{{itemSubtitle}}/g, item.product_type);;
      cartItem = cartItem.replace(
        /{{itemComparePrice}}/g,
        item.original_price > item.price
          ? this.moneyFormat(item.original_price)
          : ""
      );
      cartItem = cartItem.replace(
        /{{itemPrice}}/g,
        this.moneyFormat(item.price)
      );
      cartItem = cartItem.replace(/{{itemOptions}}/g, buildOptions(item));
      cartItem = cartItem.replace(/{{itemProps}}/g, buildProps(item));
      cartItem = cartItem.replace(/{{itemQuantity}}/g, item.quantity);
    }
    return cartItem;
  }

  hideOnEscape(e) {
    var keyCode = e.keyCode;
    if (keyCode === 27 && this.minicart) {
      this.minicart.classList.remove("open");
      this.minicart.classList.add("close");
    }
  }

  moneyFormat(amout, customCurrency = "$") {
    if (!amout) return "";
    if (typeof Shopify.formatMoney === "function") {
      const currency = Shopify.money_format.split("{")[0];
      return Shopify.formatMoney(amout, `${currency}{{amount}}`);
    } else {
      const currency = customCurrency;
      return `${currency}${amout / 100}`;
    }
  }
  
  flatMoneyFormat(amount) {
    if (!amount) return "";
    return `${amount / 100}`;
  }

  findAncestor(el, sel) {
    while (
      (el = el.parentElement) &&
      !(el.matches || el.matchesSelector).call(el, sel)
    );
    return el;
  }

  getProductForm() {
    const e = document.querySelector('form[action^="/cart/add"][data-delm-is-primary-form="true"]') ? document.querySelectorAll('form[action^="/cart/add"][data-delm-is-primary-form="true"]') : document.querySelectorAll('form[action^="/cart/add"]')
    const t = [...e].find((e => e.getAttribute("data-product-id") || e.getAttribute("data-productid")));
    return null != t ? t : null == e ? void 0 : e[0]
  }

  getSelectedVariant() {
      const e = this.getProductForm();
      if (e) {
        const t = e.querySelector('[name="id"]');
        if (t) return t.value
      }
      if ("undefined" != typeof URLSearchParams) {
        const e = new URLSearchParams(window.location.search).get("variant");
        if (e) return e
      }
      return null
  }
}

const mini_cart = new MiniCart();

if (window.rivets) {
  if (!window.CROSS_SELL_CONTROLLER) {
    CROSS_SELL_CONTROLLER = {
      CROSS_SELLS: undefined,
      CROSS_SELL_COUNT: 0,
    };
  }
  // rivets.binders["cross-sells"] = function (el) {
  //   // mini_cart.initializeCrossSells();
  //   console.log('rivets binded')
  //   console.log(el)
  // };
  rivets.binders["style-*"] = function (el, value) {
    el.style.setProperty(this.args[0], value);
  };
  rivets.binders["cart-js-add-to-cart"] = function (el) {
    // Add to cart if CartJS Present
    if (window.CartJS && !el.dataset.cartJsAddBound) {
      el.dataset.cartJsAddBound = "true";
      el.addEventListener("click", function () {
        CartJS.addItem(el.dataset.productId, 1);
      });
    }
  };
  rivets.formatters.getImage = function (item) {
    const imageURL = item.image
    const ext = imageURL.match(/\.(?:jpg|gif|png)/g);
    const sizedURL = imageURL.replace(ext[0], `_300x` + ext[0])
    const blurURL = imageURL.replace(ext[0], `_150x` + ext[0])
      return `
        <img
          class="responsive-image__image lazyload mini-cart blur-up"
          data-srcset="${sizedURL}"
          src="${blurURL}"
          alt="${item.title}"
        >`
  }
  rivets.formatters.jsonStringify = function (val) {
    return JSON.stringify(val);
  };
  rivets.formatters.hasVisibleCrossSells = function (cartItems) {
    return CROSS_SELL_CONTROLLER.CROSS_SELL_COUNT > 0;
  };
  rivets.formatters.deriveCrossSells = function (item) {
    const crossSells = [];
    const crossSellIds = [];
    mini_cart.itemsJSON.push(item);
    const cartVariantIds = mini_cart.itemsJSON.map((item) => item.variant_id);
    const cartProductIds = mini_cart.itemsJSON.map((item) => item.product_id);
    
    
    const currentVariantIds = [item.variant_id];
    const currentProductIds = [item.product_id];

    const cartCrossSellsElement = document.querySelector("#CartCrossSells");
    if (cartCrossSellsElement?.textContent) {
      const productCrossSells = JSON.parse(
        cartCrossSellsElement.textContent
      ).crossSells;
      productCrossSells.forEach((product) => {
        //Products can be null
        if(product) {
          const crossSellParent = Object.keys(product)[0];     
          //apply for the currently iterated item only
          if(
            currentVariantIds.includes(parseInt(crossSellParent)) ||
            currentProductIds.includes(parseInt(crossSellParent))
          ) {
            if (
              cartProductIds.includes(parseInt(crossSellParent)) ||
              cartVariantIds.includes(parseInt(crossSellParent))
            ) {
              product[crossSellParent].forEach((crossSell) => {
                // Make sure that it isn't in the cart
                if (
                  !cartProductIds.includes(crossSell.id) &&
                  !cartVariantIds.includes(crossSell.id)
                ) {
                  if (!crossSellIds.includes(crossSell.id)) {
                    // Only push if we don't already have it
                    crossSells.push(crossSell);
                    crossSellIds.push(crossSell.id);
                  }
                }
              });
            }
          }  
        }
        
      });
    }
    CROSS_SELL_CONTROLLER.CROSS_SELL_COUNT = crossSells.length;
    return crossSells;
  };
}

const handleExternalCartChange = function(eventObject, options = {}) {
  const { openCart = false, initializeCrossSells = false } = options;
  const cartObject = mini_cart.getCartFromEventDetail(eventObject?.detail);

  if (!cartObject) {
    return;
  }

  mini_cart.applyCartState(cartObject, openCart);

  if (initializeCrossSells) {
    mini_cart.initializeCrossSells();
  }

  mini_cart.itemsJSON = [];
};

document.addEventListener('cart.requestComplete', function(eventObject) {
  handleExternalCartChange(eventObject, {
    openCart: true,
    initializeCrossSells: true
  });
});

document.addEventListener('rebuy:cart.change', function(eventObject) {
  handleExternalCartChange(eventObject);
});

window.mini_cart = mini_cart;

// Init Cart Items
mini_cart.refreshCartSummary();

// Hide MiniCart on Escape keydown
document.addEventListener("keydown", function (e) {
  mini_cart.hideOnEscape(e);
});

// MiniCart Events
document.addEventListener("click", function (e) {
  mini_cart.openCart(e.target);
  mini_cart.removeCartItem(e.target);
  // mini_cart.plusCartItem(e.target);
  // mini_cart.minusCartItem(e.target);
  mini_cart.closeCart(e.target);
  if(e.target.classList.contains('pw-toggle') || e.target.closest('.pw-toggle')) {
    //check if enabled

  }
});


document.addEventListener("DOMContentLoaded", function(){
  mini_cart.initCartBubbleObserver();
  mini_cart.scheduleCartBubbleRefresh(0); 

  // identify an element to observe
  elementToObserve = window.document.querySelector('.route-div');
  if (!elementToObserve || !window.MutationObserver) return;

  // create a new instance of 'MutationObserver' named 'observer', 
  // passing it a callback function
  observer = new MutationObserver(function(mutationsList, observer) {
      if(mutationsList[0].addedNodes.length > 0) {
        //new data has been inserted
        setTimeout(function(){
          try{
            if(document.querySelector("route-protect-widget").getAttribute('quote') && document.querySelector("route-protect-widget").getAttribute('status') == "true") {
              document.querySelector('.one-click-insurance').classList.remove('lb-hidden')
              document.querySelector('.insurance-cost').innerText = `+ ${document.querySelector("route-protect-widget").getAttribute('quote')}`;
              
            }
          } catch {
            //do nothing
          }
        }, 100);
      } else {
        //some mutaion triggered, check if pw has been toggled
        setTimeout(function(){
          
        }, 100);
      }
      try{
        if(document.querySelector(".pw-switch").getAttribute('aria-checked') == 'true') {
          document.querySelector('.one-click-insurance').classList.remove('lb-hidden')
        } else {
          document.querySelector('.one-click-insurance').classList.add('lb-hidden')
        }
      } catch {

      }
  });

  // call 'observe' on that MutationObserver instance, 
  // passing it the element to observe, and the options object
  observer.observe(elementToObserve, {characterData: false, childList: true, attributes: true, subtree: true});
})
